import { AccountsRegisterRequest, AccountsState } from '@/shared/types/Accounts';

import { ACCOUNTS_API_URL } from './constants';
import { del, get, post } from './requestMethods';

const ACCOUNTS_URL = `${ACCOUNTS_API_URL}/users`;
export const CURRENT_ACCOUNT_URL = `${ACCOUNTS_URL}/current`;

export const ACCOUNTS_API = {
  createAccount: async (data: AccountsRegisterRequest) => post<AccountsState>(ACCOUNTS_URL, { data }),
  deleteAccount: async () => del<void>(CURRENT_ACCOUNT_URL),
  getAccount: async () => get<AccountsState>(CURRENT_ACCOUNT_URL),
};
